import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Products() {
  const [products, setProducts] = useState([]);

  const navigate = useNavigate();

  const getAndSetProducts = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/products`);

      setProducts(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAndSetProducts();
  }, []);

  const handleDeleteProduct = async (id) => {
    const verification = window.confirm("Are you sure?");
    if (!verification) {
      return;
    }
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/admin/products/` + id
      );
      getAndSetProducts();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditProduct = async (id) => {
    navigate("/admin/products/" + id);
  };

  return (
    <div className="container my-5 mt-2">
      <h2 className="m-0 mb-3 p-0">Products</h2>
      <table className="table">
        <thead>
          <tr>
            <th className="text-start" scope="col">
              Id
            </th>
            <th scope="col">Img</th>
            <th className="text-start" scope="col">
              Name
            </th>
            <th className="text-start" scope="col">
              Category
            </th>
            <th className="text-start" scope="col">
              Stock
            </th>
            <th scope="col">Options</th>
          </tr>
        </thead>
        <tbody>
          {products.map((prod) => (
            <tr key={prod._id}>
              <th className="text-start" scope="row">
                {prod._id}
              </th>
              <td style={{ height: "6rem" }}>
                <img
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  src={prod.img}
                  alt={prod.name}
                />
              </td>
              <td className="text-start">{prod.name}</td>
              <td className="text-start">{prod.category}</td>
              <td className="text-start">{prod.stock}</td>
              <td>
                <button
                  onClick={() => handleEditProduct(prod._id)}
                  className="btn btn-primary me-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDeleteProduct(prod._id)}
                  className="btn btn-danger"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
